const defaultReducer = (state, action) => {
    return {...state, ...action}
}

export const funcReducer = (state, action) => {
    if (typeof action === "function") {
      return action(state); // Call the function with the current state
    }
    return { ...state, ...action };
  };

export const lockedReducer = (state, action) => {
    const returnActions = Object.fromEntries(Object.entries(action).filter(([key, value])=> key in state))
    return {...state, ...returnActions}
}

export default defaultReducer